// extracted by mini-css-extract-plugin
export var content = "structured-text-default-module--content--56def";
export var image = "structured-text-default-module--image--a04d3";
export var imagePost = "structured-text-default-module--imagePost--ba6d1";
export var inlineRecord = "structured-text-default-module--inline-record--b8b6e";
export var player = "structured-text-default-module--player--b734c";
export var structuredPlayer = "structured-text-default-module--structuredPlayer--16b45";
export var wrapperPlayer = "structured-text-default-module--wrapperPlayer--6d4b0";